import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import {
  getRequestTypeStage,
  getRequestTypeDocs,
  addMobileOrEmailKra,
  createPhoneReasonApi,
} from "designs/v1/pages/ModifyKyc/services";

const MobileModificationReason = ({
  stageScreen,
  setStageScreen,
  setStep,
  isContinue,
  setIsContinue,
  isLoading,
  setIsLoading,
  activeUserDetail,
}) => {
  const initialValues = {
    reason: "",
  };
  const validationSchema = Yup.object().shape({
    reason: Yup.string().required(),
  });

  const handleSubmit = async (value) => {
    const stageTypes = ["Mobile Modification", "Email Modification"];
    const docName = [];
    for (const element of stageTypes) {
      const payload = {
        request_type: element,
        doc_name: localStorage.getItem(element.split(" ")[0] + "RequestNumber"),
        ...value,
      };
      setIsLoading(true);
      try {
        await addMobileOrEmailKra({
          request_type: element,
          document_name: localStorage.getItem(
            element.split(" ")[0] + "RequestNumber"
          ),
          pan_number: activeUserDetail.poi?.[0]?.pan_number,
          dob: activeUserDetail.poi?.[0]?.dob?.split("-").reverse().join("-"),
        });
        try {
          await createPhoneReasonApi(payload);
          docName.push(payload.doc_name);
        } catch (error) {
          const { data } = error.response || {};
          toast.error(
            data.message?.message || "Internal server error!"
          );
          setIsLoading(false);
        }
      } catch (error) {
        const { data } = error.response || {};
        toast.error(
          data.message?.message || "Internal server error!"
        );
        setIsLoading(false);
      }
    }
    setIsLoading(false);
    const requestTypes = getRequestTypeStage();
    const requestTypesDocs = getRequestTypeDocs() || [];
    requestTypesDocs.push(...docName);
    if (requestTypes && requestTypes.length > 0) {
      requestTypes.shift();
      localStorage.setItem("RequestTypeStage", JSON.stringify(requestTypes));
      localStorage.setItem("RequestTypeDocs", JSON.stringify(requestTypesDocs));
      Swal.fire({
        title: "Your Mobile and Email Modification Request Saved. Thank You..!",
        icon: "success",
        showCloseButton: false,
        showConfirmButton: false,
        timer: 3000,
      });
      if (requestTypes.length === 0) {
        setTimeout(async () => {
          await setStageScreen("MultipleRequestTypes");
        }, 3000);
        return;
      }
      setTimeout(async () => {
        await setStageScreen(requestTypes[0]);
      }, 3000);
      return;
    }
  };

  return (
    <>
      <Title title="Reason" />
      <div className="row">
        <div className="col-md-9">
          <div className="form-group">
            <div className="mb-2">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ isValid, dirty, isSubmitting }) => (
                  <Form>
                    <div className="form-group my-2">
                      <label className="py-1">
                        Reason (maximum 150 characters):
                      </label>
                      <Field
                        type="text"
                        name="reason"
                        placeholder="Enter your reason here..."
                        className="form-control"
                        as="textarea"
                        maxLength={150}
                        rows={3}
                        autoFocus
                      />
                    </div>
                    <div className="d-flex form-group my-4">
                      <div className="">
                        <Button
                          title="Back"
                          type="button"
                          handleClick={() => {
                            setStep(
                              isContinue
                                ? "CheckPrevRequest"
                                : "MobileModification"
                            );
                            setIsContinue(false);
                          }}
                        />
                      </div>
                      <div className="mx-2">
                        <Button
                          title="Submit"
                          disabled={
                            !isValid || !dirty || isSubmitting || isLoading
                          }
                        />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileModificationReason;
